import { render, staticRenderFns } from "./contactsTags.vue?vue&type=template&id=3aa44e2a&scoped=true"
import script from "./contactsTags.vue?vue&type=script&lang=js"
export * from "./contactsTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa44e2a",
  null
  
)

export default component.exports